import { Button, Col, Form, Input, InputNumber, Row, Select, Spin } from 'antd';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { CreateTemplateInput } from '../../API';
import { IFormWithSelectProps } from '../../typings';
import { IMAGE_WIDTH } from '../../utils';

interface Props extends Pick<CreateTemplateInput, 'textLayers'>, IFormWithSelectProps {
  selectLoading?: boolean;
  onSelectScroll?: (event: React.UIEvent<HTMLDivElement, UIEvent>) => Promise<void>;
}

const { Item } = Form;

export const CampaignForm = ({
  loading,
  initialValues,
  selectLoading = false,
  options,
  onSelectScroll,
  textLayers,
  ...rest
}: Props) => {
  const { t } = useTranslation();

  return (
    <Form {...rest} initialValues={{ width: IMAGE_WIDTH.DEFAULT, ...initialValues }}>
      <Item label={t('CAMPAIGN_NAME_LABEL')} name="name" extra={t('CAMPAIGN_NAME_EXTRA')} rules={[{ required: true }]}>
        <Input />
      </Item>
      <Item label={t('TEMPLATE')} name="templateId" rules={[{ required: true }]}>
        <Select
          options={options}
          onPopupScroll={onSelectScroll}
          loading={selectLoading}
          dropdownRender={(menu) => {
            return (
              <>
                {menu}
                {selectLoading && (
                  <Row justify="center">
                    <Col>
                      <Spin size="default" />
                    </Col>
                  </Row>
                )}
              </>
            );
          }}
        />
      </Item>
      {textLayers?.length
        ? textLayers.map(({ name }, index) => (
            <Item
              key={name}
              label={
                textLayers.length === 1
                  ? t('SINGLE_PLACEHOLDER_TEXT_LABEL')
                  : t('MULTI_PLACEHOLDER_TEXT_LABEL', { index: index + 1 })
              }
              name={['customText', name]}
              extra={t('PLACEHOLDER_TEXT_EXTRA')}
            >
              <Input />
            </Item>
          ))
        : null}
      <Item
        label={t('IMAGE_WIDTH_LABEL')}
        extra={t('IMAGE_WIDTH_EXTRA', { min: IMAGE_WIDTH.MIN, max: IMAGE_WIDTH.MAX })}
        name="width"
        rules={[{ required: true }]}
      >
        <InputNumber min={IMAGE_WIDTH.MIN} max={IMAGE_WIDTH.MAX} />
      </Item>
      <Item style={{ marginBottom: 0 }} extra={textLayers?.length ? t('SAVE_BUTTON_EXTRA') : undefined}>
        <Button type="primary" htmlType="submit" loading={loading}>
          {t('SAVE_BUTTON')}
        </Button>
      </Item>
    </Form>
  );
};
